import { V2_COOKIE_AUTH } from './axiosInstance';

export function sseAuthConfig(extraHeaders: Record<string, string> = {}): {
  headers: Record<string, string>;
  withCredentials: boolean;
} {
  return { headers: { ...extraHeaders }, withCredentials: V2_COOKIE_AUTH };
}
